<template>
  <div class="parameter-container">
    <b-card>
      <div style="display: none">{{ compareMode }}</div>
      <div style="display: flex">
        <variable-selector
          v-model="selectedVariable"
          :variableMap="variableMap"
          :viewType="viewType"
          :modelType="modelType"
          :value="propSelectedVariable"
          class="m-1 variableList"
          style="width: 200px"
        ></variable-selector>
        <time-selector
          v-model="timeType"
          :variableMap="variableMap"
          :viewType="viewType"
          :modelType="modelType"
          :variableNotation="selectedVariable"
          :value="propTimeType"
          class="m-1 timeTypeList"
          style="width: 100px"
        ></time-selector>
        <process-type-selector
          v-model="processType"
          :variableMap="variableMap"
          :viewType="viewType"
          :modelType="modelType"
          :dateRangeStart="dateRangeStart"
          :variableNotation="selectedVariable"
          class="m-1 processTypeList"
        ></process-type-selector>
        <process-sub-type-selector
          v-model="processSubType"
          :viewType="viewType"
          :modelType="modelType"
          :processType="processType"
          :timeType="timeType"
          :variableMap="variableMap"
          :variableNotation="selectedVariable"
          :qSubTypeMap="qSubTypeMap"
          class="m-1 processSubTypeList"
          v-show="viewType == 'mapView' && processType != 'o' && processType"
        ></process-sub-type-selector>
      </div>
      <div style="display: flex">
        <base-selector
          v-model="base"
          :value="propBase"
          :viewType="viewType"
          :modelType="modelType"
          :containerNumber="containerNumber"
          class="m-1"
          style="float: left; flex-grow: 0"
        ></base-selector>
        <vue-slider
          ref="slider"
          class="rangeSlider"
          style="
            width: 355px;
            float: left;
            margin: 8px;
            margin-top: 0px;
            margin-left: 15px;
            font-size: 1em;
            flex-grow: 1;
          "
          v-model="dateRangeStart"
          v-bind="dateRangeOptions"
          v-show="viewType == 'mapView'"
        >
          <template v-slot:label="{ active, value }">
            <div :class="['vue-slider-mark-label', 'custom-label', { active }]">
              {{ value % 10 == 1 ? value : "" }}
            </div>
          </template>
        </vue-slider>
      </div>
      <div style="display: flex">
        <AggregationModeSelector
          :chosedAggregationMode="aggregationModeForGraph"
        />
        <div v-if="viewType == 'graphView'" style="flex-grow: 1"></div>
        <b-button
          v-if="viewType == 'graphView'"
          :disabled="!selectedVariable"
          style="float: right; height: 35px; font-size: 1.25rem !important"
          class="m-1 graphDownload"
          variant="primary"
          @click="$store.state.parameterStripe.downloadChartF()"
          >Grafikon letöltése</b-button
        >
      </div>
      <span
        v-show="showDebugValues"
        style="font-size: 12px; background-color: aliceblue; color: black"
        >{{ definitionQuery }}</span
      >
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "@/config/config.js";
import AggregationModeSelector from "@/components/AggregationModeSelector.vue";
import Multiselect from "vue-multiselect";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import VariableSelector from "@/components/parameterComponents/VariableSelector.vue";
import TimeSelector from "@/components/parameterComponents/TimeSelector.vue";
import ProcessTypeSelector from "@/components/parameterComponents/ProcessTypeSelector.vue";
import ProcessSubTypeSelector from "@/components/parameterComponents/ProcessSubTypeSelector.vue";
import BaseSelector from "@/components/parameterComponents/BaseSelector.vue";
import { watch } from "vue";

export default {
  name: "ParameterContainer",
  components: {
    AggregationModeSelector,
    Multiselect,
    VueSlider,
    VariableSelector,
    TimeSelector,
    ProcessTypeSelector,
    ProcessSubTypeSelector,
    BaseSelector,
  },
  props: {
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    variableMap: {
      type: Map,
      default: new Map(),
    },
    qSubTypeMap: {
      type: Map,
      default: new Map(),
    },
    aggregationModeForGraph: {
      type: String,
      default: "daily",
    },
    compare: {
      type: Boolean,
      default: false,
    },
    containerNumber: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    compareMode() {
      return this.$store.state.parameterStripe.compare;
    },
    showDebugValues() {
      return config.showDebugValues;
    },
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    },
    definitionQuery: function () {
      if (
        !this.viewType ||
        !this.modelType ||
        !this.selectedVariable ||
        !this.timeType ||
        !this.processType ||
        !this.variableMap.has(this.viewType) ||
        !this.variableMap.get(this.viewType).has(this.modelType) ||
        !this.variableMap
          .get(this.viewType)
          .get(this.modelType)
          .has(this.selectedVariable)
      ) {
        if (this.viewType && this.modelType && this.selectedVariable) {
          let variableNotation = this.selectedVariable;
          let viewType = this.viewType;
          let modelType = this.modelType;
          let variableObject = this.variableMap
            .get(viewType)
            .get(modelType)
            .get(variableNotation);
          if (variableObject && variableObject.raster_function_name) {
            //TODO: itt eltérni, ha nem az első paramétert állítjuk be
            if (this.containerNumber == 1) {
              this.$store.state.parameterStripe.variable1_raster_function =
                variableObject.raster_function_name;
            } else if (this.containerNumber == 2) {
              this.$store.state.parameterStripe.variable2_raster_function =
                variableObject.raster_function_name;
            }
          } else return "";
        }

        return "";
      }

      let model;
      let area;
      let process_type = this.processType;
      let process_sub_type = this.processSubType;
      let extension;

      if (this.viewType == "graphView") {
        extension = ".txt";
        if (this.modelType == "climate") {
          model = "RCM";
        } else if (this.modelType == "city") {
          model = "SFX";
        }
      } else if (this.viewType == "mapView") {
        extension = ".tif";
        if (this.modelType == "climate") {
          area = this.base;
          if (this.dateRangeStart <= this.currentYear - 29) {
            model = "OBS";
          } else {
            model = "RCM";
          }
        } else if (this.modelType == "city") {
          area = this.base;
          if (this.dateRangeStart <= this.currentYear - 29) {
            model = "OBS";
          } else {
            model = "SFX";
          }
        }
      }

      let variableNotation = this.selectedVariable;
      let viewType = this.viewType;
      let modelType = this.modelType;
      let variableObject = this.variableMap
        .get(viewType)
        .get(modelType)
        .get(variableNotation);

      let yearRange = "" + this.dateRangeStart + (this.dateRangeStart + 29);

      let process_decription = "";
      if (process_type == "o") {
        process_decription = "o_0";
      } else if (process_type == "p") {
        process_decription = process_type + "_" + process_sub_type;
      } else {
        if (
          process_sub_type &&
          process_sub_type.indexOf("c") == -1 &&
          process_sub_type.indexOf("q") == -1
        )
          process_decription = process_type + "_" + process_sub_type;
        else process_decription = process_sub_type;
      }
      console.log(process_decription);

      let name =
        model +
        "_" +
        this.selectedVariable +
        "_" +
        yearRange +
        "_" +
        this.timeType +
        "_" +
        process_decription +
        "_" +
        area; //+ extension;
      var image_service_url; //TODO átírni
      if (area == "HU") {
        image_service_url = config.imageService.url_hu;
      } else if (area == "MEGYE") {
        image_service_url = config.imageService.url_megye;
      } else {
        image_service_url = config.imageService.url_jaras;
      }
      let def_query = "  name = '" + name + "'";

      let rasterFunction;
      //TODO: refaktor: it should depend on variable_notation, process type and model type (different for rcm and sfx)
      let rf_model;
      if (model == "OBS") {
        if (this.modelType == "climate") {
          rf_model = "rcm";
        } else if (this.modelType == "city") {
          rf_model = "sfx";
        }
      } else {
        rf_model = model.toLowerCase();
      }
      let process_char;
      if (process_type == "p") {
        process_char = "p";
      } else if (process_type == "o") {
        process_char = "o";
      } else if (process_type == "q") {
        if (process_sub_type) {
          process_sub_type.indexOf("c") === -1
            ? (process_char = "q")
            : (process_char = "c");
        } else {
          process_char = "q";
        }
      }
      console.warn(
        "new raster function name: " +
          variableNotation +
          "_" +
          process_char +
          "_" +
          rf_model,
      );
      let new_raster_function_name =
        variableNotation + "_" + process_char + "_" + rf_model;
      /*if (process_type == "p") {
        rasterFunction = variableObject.raster_function_p;
      } else if (process_type == "o") {
        rasterFunction = variableObject.raster_function_o_q;
      } else if (process_type == "q") {
        //TODO: tesztelni, hogy jó-e így
        if (process_sub_type && process_sub_type.indexOf("c") === -1) {
          rasterFunction = variableObject.raster_function_o_q;
        } else {
          rasterFunction = variableObject.raster_function_c;
        }
      }*/
      rasterFunction = new_raster_function_name;
      //TODO: itt eltérni, ha nem az első paramétert állítjuk be
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.variable1_raster_function = rasterFunction;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.variable2_raster_function = rasterFunction;
      }
      //this.$store.state.parameterStripe.variable1_raster_function = rasterFunction;
      //TODO: itt eltérni, ha nem az első paramétert állítjuk be
      this.$root.$refs.MapRef.changleLayer(
        image_service_url,
        def_query,
        rasterFunction,
        this.containerNumber,
      );
      //TODO: itt eltérni, ha nem az első paramétert állítjuk be
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.raster_name_1 = name;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.raster_name_2 = name;
      }
      //this.$store.state.parameterStripe.raster_name_1 = name;
      return name;
    },
  },
  data() {
    return {
      selectedVariable: "",
      propSelectedVariable: "",
      timeType: null,
      propTimeType: null,
      processType: null,
      processSubType: null,
      base: "HU",
      propBase: null,
      dateRangeStart: 1971,
      dateRangeOptions: {
        dotSize: 14,
        width: "auto",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 1971,
        max: 2071,
        interval: 5,
        disabled: false,
        clickable: true,
        duration: 0.3,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "bottom",
        tooltipFormatter: (start) => start + "-" + (start + 29), //void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: true,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    };
  },
  watch: {
    viewType(newVal) {
      this.$options.watch.selectedVariable.call(this, this.selectedVariable);
    },
    modelType(newVal) {
      //this.variableMap.get(this.viewType).get(this.modelType).has(this.selectedVariable);
      this.$options.watch.selectedVariable.call(this, this.selectedVariable);
    },
    selectedVariable(newVal) {
      if (!newVal) {
        if (this.containerNumber == 1)
          this.$store.state.parameterStripe.variable_1_notation = null;
        else if (this.containerNumber == 2)
          this.$store.state.parameterStripe.variable_2_notation = null;
        return;
      }
      this.$store.state.parameterStripe.variable_1_notation = newVal;
      let viewType = this.viewType;
      let modelType = this.modelType;
      let variableObject = this.variableMap
        .get(viewType)
        .get(modelType)
        .get(newVal);
      console.log(variableObject);
      if (variableObject && variableObject.variable_name) {
        if (this.containerNumber == 1) {
          this.$store.state.parameterStripe.variable1_display_name =
            variableObject.variable_name;
        } else if (this.containerNumber == 2) {
          this.$store.state.parameterStripe.variable2_display_name =
            variableObject.variable_name;
        }
      }
      if (variableObject && variableObject.unit) {
        if (this.containerNumber == 1) {
          this.$store.state.parameterStripe.variable1_unit =
            variableObject.unit;
        } else if (this.containerNumber == 2) {
          this.$store.state.parameterStripe.variable2_unit =
            variableObject.unit;
        }
      }
      if (variableObject && variableObject.graph_color_class) {
        if (this.containerNumber == 1) {
          this.$store.state.parameterStripe.variable1_chart_color =
            variableObject.graph_color_class;
        } else if (this.containerNumber == 2) {
          this.$store.state.parameterStripe.variable2_chart_color =
            variableObject.graph_color_class;
        }
      } else {
        this.$store.state.parameterStripe.variable1_chart_color = undefined;
      }
      //return variableObject.graph_color_class;
    },
    timeType(newVal) {
      //TODO: Itt vajon tényleg csak egy van? Ez csak akkor legyen állítva, ha az első konténerben vagyunk
      if (this.containerNumber == 1)
        this.$store.state.parameterStripe.idoszak1 = this.timeType;
      else if (this.containerNumber == 2)
        this.$store.state.parameterStripe.idoszak2 = this.timeType;
    },
    processType(newVal) {
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.processType1 = newVal;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.processType2 = newVal;
      }
    },
    processSubType(newVal) {
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.processSubType1 = newVal;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.processSubType2 = newVal;
      }
    },
    base(newVal) {
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.base1 = newVal;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.base2 = newVal;
      }
      //this.$store.state.parameterStripe.base = newVal;
    },
    dateRangeStart(newVal) {
      if (this.containerNumber == 1) {
        this.$store.state.parameterStripe.dateRangeStart1 = newVal;
      } else if (this.containerNumber == 2) {
        this.$store.state.parameterStripe.dateRangeStart2 = newVal;
      }
      //this.$store.state.parameterStripe.dateRangeStart1 = newVal;
    },
    compareMode(newVal) {
      //TODO: Here want to copy the data from the first parameter container to the second one
      //when compare is set to true
      console.warn(
        "compare change catched:",
        newVal,
        "containerNumber",
        this.containerNumber,
      );
      if (newVal) {
        if (this.containerNumber == 2) {
          this.selectedVariable = this.$store.state.parameterStripe.variable_1_notation;
          //this.timeType = "02";
          console.warn("set propSelectedVariable to:", this.selectedVariable);
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.timeType = this.$store.state.parameterStripe.idoszak1;
              this.processType = this.$store.state.parameterStripe.processType1;
              this.processSubType = this.$store.state.parameterStripe.processSubType1;
              this.base = this.$store.state.parameterStripe.base1;
              this.dateRangeStart = this.$store.state.parameterStripe.dateRangeStart1;
            }, 2000);
            /*this.timeType = this.$store.state.parameterStripe.idoszak1;
            cessType = this.$store.state.parameterStripe.processType1;
            this.processSubType = this.$store.state.parameterStripe.processSubType1;
            this.base = this.$store.state.parameterStripe.base1;
            this.dateRangeStart = this.$store.state.parameterStripe.dateRangeStart1;*/
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.variableList {
  flex-grow: 1;
}
.timeTypeList {
  flex-grow: 1;
}

.processTypeList {
  flex-grow: 0;
}

.processSubTypeList {
  flex-grow: 1;
}
</style>
